
import { Component, Input } from '@angular/core';

export type TagType = 'info' | 'success' | 'danger' | 'warning';

@Component({
  selector: 'app-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  imports: [],
})
export class TagComponent {
  @Input() id?: string;
  @Input() type: TagType = 'info';

  get tagType() {
    return this.type;
  }
}
